import { GET_GRADING_CRITERIAS } from '../actions/gradingCriteriaActions';

/**
 * Manejo de la parte del estado correspondiente a matrices de codificación.
 * Permite la actualización de matrices de codificación, obtener una matriz de codificación por id.
 * Permite eliminar una matriz de codificación de la lista de matrices de codificación disponibles.
 *
 * @export
 * @param {*} [state={}] : estado de la aplicación
 * @param {*} action : operación a realizar sobre el estado (correspondiente a las matrices)
 * @returns El estado con la modificación/acción realizada.
 */

const initialState = {
  gradingCriterias: [],
  gradingCriteria: undefined,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_GRADING_CRITERIAS:
      return {...state, gradingCriterias: action.payload};
    default:
      return state;
  }
}
